export const dateParser = (d) => {
  return new Date(d).toLocaleString("fa-ir");
};
